<template>
  <div>
    <vx-card
      class="mb-4"
      v-if="$can('Gerar Arquivo Remessa', 'Arquivo Remessa')"
    >
      <vx-card
        v-for="(geracao, index) of listBoletos"
        :key="index"
        :class="{ 'mb-6': index < listBoletos.length - 1 }"
      >
        <div>
          <p class="h5 mb-2">
            Carteira de Cobrança: {{ geracao.nomeCarteira }}
          </p>

          <p class="mb-4" v-if="geracao.totalBoleto > 1">
            Existem {{ geracao.totalBoleto }} boletos aguardando a geração do
            arquivo remessa
          </p>

          <p class="mb-4" v-if="geracao.totalBoleto == 1">
            Existe {{ geracao.totalBoleto }} boleto aguardando a geração do
            arquivo remessa
          </p>

          <vs-button type="border" @click="openConfirm(geracao.idCarteira)">
            Gerar Arquivo Remessa
          </vs-button>
        </div>
      </vx-card>

      <span v-if="listBoletos.length == 0">
        Não existem boletos aguardando a geração do arquivo remessa
      </span>
    </vx-card>

    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhum Arquivo Remessa encontrado"
          class="tablePrincipal"
          ref="table"
          pagination
          :max-items="itemsPerPage"
          search
          :data="listArquivosRemessa"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <!-- Empty -->
            <div></div>

            <!-- Seleção das Páginas -->
            <SelectPagination
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
              :length="listArquivosRemessa.length"
              @update="itemsPerPage = $event"
            />
          </div>

          <template slot="thead">
            <vs-th>Controle</vs-th>
            <vs-th>Data Geração</vs-th>
            <vs-th>Nome Arquivo</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- ID -->
                <vs-td>
                  {{ tr.idRemessasArquivo }}
                </vs-td>

                <!-- Data Geração -->
                <vs-td>
                  {{ tr.createdAt | formatDate }}
                </vs-td>

                <!-- Nome Arquivo -->
                <vs-td>
                  {{ getNameFile(tr.linkArquivo) }}
                </vs-td>

                <!-- Download -->
                <vs-td>
                  <a :href="tr.linkArquivo"
                    ><vs-button
                      color="dark"
                      type="relief"
                      icon-pack="feather"
                      icon="icon-download"
                      class="d-inline mr-3"
                      >Download</vs-button
                    ></a
                  >
                  <vs-button
                    v-if="!tr.dataBoletosGerados"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-dollar-sign"
                    class="d-inline"
                    @click="gerarBoletos(tr)"
                    >Gerar Boletos</vs-button
                  >
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import service from './../../../services';
import SelectPagination from './../../../utils/list/header/SelectPagination';
import notify from './../../../utils/notify';

export default {
  data() {
    return {
      itemsPerPage: 10,
      listArquivosRemessa: [],
      listBoletos: [],
      isMounted: false,
    };
  },
  methods: {
    load() {
      return new Promise(async (resolve) => {
        try {
          this.$vs.loading();
          await this.getListArquivosRemessas();
          await this.getCountBoletos();
        } catch (error) {
          this.$vs.loading.close();
        } finally {
          this.$vs.loading.close();
          resolve();
        }
      });
    },
    async getListArquivosRemessas() {
      try {
        const action = `list/idEmpresa=null`;
        const getAll = await service.getAll('RemessasArquivos', {}, action);

        if (Array.isArray(getAll.data)) {
          this.listArquivosRemessa = getAll.data;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async getCountBoletos() {
      try {
        const action = `countBoletos/idEmpresa=null`;
        const getAll = await service.getAll('RemessasArquivos', {}, action);

        this.listBoletos = getAll.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    getNameFile(link) {
      const array = link.split('/');
      return array[array.length - 1].replace('.txt', '');
    },
    async gerarBoletos(tr) {
      try {
        this.$vs.loading();
        const action = `geraBoletosDefinitivo/${tr.idRemessasArquivo}`;
        const getAll = await service.getAll('RemessasArquivos', {}, action);
        const result = getAll.data;

        if (result) {
          this.$vs.loading.close();
          this.$vs.dialog({
            color: 'success',
            title: 'Geração de Boletos (PDF)',
            text: 'Boletos gerados com sucesso!',
            acceptText: 'OK',
            accept: this.load,
          });
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$vs.loading.close();
      }
    },
    async createFile(idCarteira) {
      try {
        this.$vs.loading();
        const action = `createFile/idEmpresa=null/idUsuario=null/${idCarteira}`;
        const getAll = await service.getAll('RemessasArquivos', {}, action);
        const result = getAll.data;

        if (result) {
          this.$vs.loading.close();
          this.$vs.dialog({
            color: 'success',
            title: 'Geração de Arquivo Remessa',
            text: 'Arquivo gerado com sucesso!',
            acceptText: 'OK',
            accept: this.load,
          });
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$vs.loading.close();
      }
    },
    openConfirm(idCarteira) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirmação`,
        text: 'Deseja gerar o arquivo remessa?',
        acceptText: 'Sim',
        cancelText: 'Não',
        accept: () => this.createFile(idCarteira),
      });
    },
  },
  created() {
    this.load();
  },
  components: {
    SelectPagination,
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style scoped>
.vs-button.includeIcon {
  float: left;
}
</style>

<style lang="scss">
#data-list-list-view {
  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
      cursor: default;
      td {
        padding: 20px;
        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }
        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }
      }
      td.td-check {
        padding: 20px !important;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
    th.td-check {
      padding: 0 15px !important;
    }
    tr {
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}
</style>
